import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNrConta'
})
export class FormatNrContaPipe implements PipeTransform {

  transform(value: string): string {
    if (!value || value.length < 2) {
      return value; 
    }

    const lastChar = value.slice(-1); 
    const secondLastChar = value.slice(-2, -1); 
    const start = value.slice(0, -2); 

    return `${start}${secondLastChar}-${lastChar}`; 
  }

}
